import { PaysafeEventHandler } from './paysafe-event-handler.type';
import { PaysafeFields } from './paysafe-fields.type';
import { PaysafePaymentMethods } from './paysafe-payment-methods.interface';
import { PaysafeTokenizationOptions } from './paysafe-tokenization-options.interface';
import { PaysafeTokenizationResponse } from './paysafe-tokenization-response.interface';

export interface PaysafeInstance {
  areAllFieldsValid: () => boolean;
  complete: () => void;
  fields: PaysafeFields;
  hostedFieldsInstanceId: string;
  on: (selector: string, eventHandler: PaysafeEventHandler) => void;
  paymentMethods: PaysafePaymentMethods;
  resetCardDetails: () => void;
  show: () => Promise<PaysafePaymentMethods>;
  submit: () => void;
  tokenize: (
    options: PaysafeTokenizationOptions
  ) => Promise<PaysafeTokenizationResponse>;
}
